var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.2188,
    r: 25,
    fill: "#D2F5EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_5437)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5957 14.6898C25.9352 14.6898 27.8532 16.6029 27.8532 18.9362V22.1592H30.1681V18.9362C30.1681 15.3274 27.2124 12.3809 23.5957 12.3809C19.9791 12.3809 17.0234 15.3274 17.0234 18.9362V22.1592H19.3384V18.9362C19.3383 16.6028 21.2563 14.6898 23.5957 14.6898Z",
    fill: "#DEDBEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1681 18.9362C30.1681 15.3274 27.2124 12.3809 23.5957 12.3809C22.8554 12.3809 22.1424 12.5047 21.4771 12.7321C21.7426 12.699 22.0125 12.6817 22.2867 12.6817C25.9033 12.6817 28.8591 15.6298 28.8591 19.2371V22.1592H30.1681V18.9362Z",
    fill: "#D2CFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8532 21.6525V18.9362C27.8532 16.6028 25.9352 14.6898 23.5957 14.6898C21.2563 14.6898 19.3383 16.6029 19.3383 18.9362V21.6525M17.0234 21.6525V18.9362C17.0234 15.3274 19.9791 12.3809 23.5958 12.3809C27.2125 12.3809 30.1682 15.3274 30.1682 18.9362V21.6525",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7447 21.6525C15.3795 21.6525 14.2625 22.7666 14.2625 24.1284V27.812C14.2625 32.9322 18.4622 37.121 23.5956 37.121C25.3419 37.121 26.98 36.6359 28.3798 35.7953L32.9288 27.0001V24.1284C32.9288 22.7667 31.8118 21.6525 30.4465 21.6525C25.8788 21.6525 21.3125 21.6525 16.7447 21.6525Z",
    fill: "#FDB441"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5957 25.2742C22.4801 25.2742 21.5752 26.1753 21.5752 27.288C21.5752 28.0063 21.9519 28.6353 22.5176 28.9938L22.0673 31.9203H25.124L24.6738 28.9938C25.2395 28.6354 25.6162 28.0063 25.6162 27.288C25.6162 26.1753 24.7113 25.2742 23.5957 25.2742Z",
    fill: "#025F80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4007 26.9742C29.4537 26.9742 27.0652 29.3566 27.0652 32.296C27.0652 33.6361 27.5616 34.8597 28.38 35.7953C29.3585 36.9123 30.7973 37.6191 32.4007 37.6191C35.3478 37.6191 37.7377 35.2353 37.7377 32.2959C37.7377 29.535 35.6291 27.265 32.9289 27.0001C32.7557 26.9829 32.5797 26.9742 32.4007 26.9742Z",
    fill: "#2CCDAD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2637 25.3001C24.0228 25.5952 24.5626 26.3409 24.5626 27.2132C24.5626 27.943 24.1859 28.5821 23.6202 28.9463L24.0704 31.9203H25.124L24.6737 28.9938C25.2395 28.6354 25.6161 28.0063 25.6161 27.288C25.6161 26.1753 24.7112 25.2742 23.5956 25.2742C23.483 25.2742 23.3719 25.2829 23.2637 25.3001Z",
    fill: "#024C67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7377 32.296C37.7377 29.535 35.6291 27.265 32.9289 27.0001C32.7558 26.9829 32.5797 26.9742 32.4007 26.9742C32.024 26.9742 31.6546 27.0131 31.2996 27.0879C33.9926 27.3586 36.0953 29.6257 36.0953 32.3838C36.0953 34.946 34.2783 37.0851 31.861 37.5918C32.0385 37.6091 32.2189 37.6192 32.4008 37.6192C35.3477 37.6192 37.7377 35.2354 37.7377 32.296Z",
    fill: "#028369"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9288 24.1284C32.9288 22.7666 31.8117 21.6525 30.4465 21.6525H30.1679H28.859H27.853C29.2183 21.6525 30.3353 22.7666 30.3353 24.1284V27.3873C30.6427 27.2592 30.966 27.1571 31.2994 27.0879C31.6544 27.0131 32.0239 26.9742 32.4005 26.9742C32.5795 26.9742 32.7556 26.9829 32.9288 27.0001V24.1284Z",
    fill: "#FE9901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5957 25.2742C24.7113 25.2742 25.6162 26.1753 25.6162 27.288C25.6162 28.0063 25.2395 28.6353 24.6738 28.9938L25.124 31.9203H22.0673L22.5176 28.9938C21.9518 28.6354 21.5752 28.0063 21.5752 27.288C21.5752 26.1753 22.4801 25.2742 23.5957 25.2742Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3813 35.7953C26.98 36.6359 25.342 37.121 23.5956 37.121C18.4622 37.121 14.2625 32.9322 14.2625 27.812V24.1284C14.2625 22.7666 15.3795 21.6525 16.7447 21.6525H22.7369M24.5006 21.6525H30.4465C31.8118 21.6525 32.9288 22.7666 32.9288 24.1284V27.0001",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7583 30.6507C30.7583 30.5729 30.7641 30.4966 30.7742 30.4218C30.8868 29.6143 31.5911 28.9953 32.4353 29.0126C33.2897 29.0298 33.9968 29.7121 34.0416 30.5643C34.0906 31.5072 33.3373 32.2888 32.4006 32.2888V34.0018",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4021 35.5721L32.4006 35.581",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8442 36.3625C34.9148 37.147 33.714 37.6192 32.4007 37.6192C29.4537 37.6192 27.0652 35.2354 27.0652 32.296C27.0652 29.3565 29.4537 26.9742 32.4007 26.9742C35.3478 26.9742 37.7377 29.3566 37.7377 32.296C37.7377 33.3281 37.4432 34.2896 36.9352 35.1044",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_5437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/Lock2.8b6cd8fc164801541918cc4acc6ca1f0.svg";
export { ForwardRef as ReactComponent };